import File from "./File.js";
import Folder from "./Folder.js";
import ModelFactory from "../../ModelFactory.js";

/**
 * `EntriesFactory` is responsible for materializing files and directories.
 */
class EntriesFactory extends ModelFactory {
	_getTypeFromJson(json) {
		if (json.isFolder) {
			return Folder;
		}
		return File;
	}

	_findClassFromType(type) {
		return type;
	}
}

const entriesFactory = new EntriesFactory();

export default entriesFactory;
